/* jshint esversion: 6 */
import utils from '../libs/utils';
import { findingFreshCategory } from '@/libs/api'

const group = 'category';

const model = {
  CATEGORY_NAV_LIST: '',
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
  Object.keys(s).forEach((key) => {
    s[key] = state[key];
  });
};



export const actions = {
  // 选项列表
  [types.CATEGORY_NAV_LIST](store, query) {
    return findingFreshCategory(query, 'jsonApiCallback').then(res => {
      return res;
    })
  },
}